import {
  DwellingClassification,
  StructureTypeType
} from '@alpinehomeair/common';

export type DwellingSuggestion = {
  typeId: number;
  subtypeId: number;
  label: string;
};

const FACTORY_BUILT_CLASSIFICATIONS: DwellingClassification[] = [
  'mobile_home',
  'manufactured_home',
  'modular_home'
];

/**
 * Resolves a structure-subtype id to its CODE across the loaded structure
 * types (code-keyed downstream, never id-keyed). Null id, unknown id, or a
 * not-yet-loaded structure-type list all resolve to null.
 */
export function subtypeCodeById(
  structureTypes: StructureTypeType[],
  subtypeId: number | null
): string | null {
  if (subtypeId == null) {
    return null;
  }
  return (
    structureTypes
      .flatMap((structureType) => structureType.subtypes)
      .find((subtype) => subtype.id === subtypeId)?.code ?? null
  );
}

/**
 * Resolves a factory-built dwelling classification to its matching structure
 * subtype by CODE (classification values intentionally equal subtype codes).
 * Returns null for site_built/unknown or when no subtype row matches.
 */
export function resolveDwellingSuggestion(
  classification: DwellingClassification,
  structureTypes: StructureTypeType[]
): DwellingSuggestion | null {
  if (!FACTORY_BUILT_CLASSIFICATIONS.includes(classification)) {
    return null;
  }

  for (const structureType of structureTypes) {
    const subtype = structureType.subtypes.find(
      (s) => s.code === classification
    );

    if (subtype) {
      return {
        typeId: structureType.id,
        subtypeId: subtype.id,
        label: subtype.label
      };
    }
  }

  return null;
}
